import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, tap } from 'rxjs';
import { CommonService } from 'src/app/shared/api-services/common.service';
import { TenantService } from 'src/app/shared/api-services/tenant.service';
import { VECTORE_API_BASE_URL } from 'src/app/shared/constant/app-config';
import {
  FuelCardTypeResponse,
  ItemImportFuelCardFileModel,
} from 'src/app/shared/models/import-fuel-card/import';
import { ItemImportFuelCardFileResponse } from 'src/app/shared/models/import-fuel-card/import-response';
import { ImportsFilter } from 'src/app/shared/models/import/import-filter';
import { ImportsFuelCardFilter } from '../models/import-fuel-card/import-filter';

@Injectable({
  providedIn: 'root',
})
export class ImportFuelCardService {
  tenantId = this._tenantService.getTenantId();
  constructor(
    private _http: HttpClient,
    private _commonService: CommonService,
    private _toasterService: ToastrService,
    private _translateService: TranslateService,
    private _tenantService: TenantService
  ) {}

  listfuelCardTypes$() {
    return this._http
      .get<FuelCardTypeResponse>(
        `${VECTORE_API_BASE_URL}/${this.tenantId}/fuel-card-types`
      )
      .pipe(
        tap({
          error: (error) => this._commonService.handleError(error),
        })
      );
  }

  createImport$(importRequest: any): Observable<ItemImportFuelCardFileModel> {
    return this._http
      .post<ItemImportFuelCardFileModel>(
        `${VECTORE_API_BASE_URL}/${this.tenantId}/fuel-card-imports`,
        importRequest
      )
      .pipe(
        tap({
          error: (error) => this._commonService.handleError(error),
        })
      );
  }

  listImports$(filter: ImportsFuelCardFilter) {
    return this._http
      .get<ItemImportFuelCardFileResponse>(
        `${VECTORE_API_BASE_URL}/${this.tenantId}/fuel-card-imports`,
        { params: this._commonService.buildParams(filter) }
      )
      .pipe(
        tap({
          error: (error) => this._commonService.handleError(error),
        })
      );
  }

  getImport$(importId: string): Observable<ItemImportFuelCardFileModel> {
    return this._http
      .get<ItemImportFuelCardFileModel>(
        `${VECTORE_API_BASE_URL}/${this.tenantId}/fuel-card-imports/${importId}`
      )
      .pipe(
        tap({
          error: (error) => this._commonService.handleError(error),
        })
      );
  }
}
